import React, { useState } from "react";
import { Box, Typography, Paper } from "@mui/material";
import {
  ArrowUpward,
  ArrowDownward,
  SentimentSatisfiedAlt,
  RecordVoiceOver,
  Timer,
} from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import PhoneIcon from "@mui/icons-material/Phone";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import SouthIcon from "@mui/icons-material/South";
import { palette, theme as colorTheme} from "../Convoze.theme";


  const primary = colorTheme('palette', 'primary').value;
  const primaryBg = colorTheme('palette', 'primaryBg').value;
  const positive = colorTheme('palette', 'positive').value;
  const negative = colorTheme('palette', 'negative').value;
  const neutral = colorTheme('palette', 'neutral').value;


const iconMap = {
  PhoneIcon: <PhoneIcon sx={{ color: primary, fontSize: 22 }} />,
  AccessTimeIcon: <AccessTimeIcon sx={{ color: primary, fontSize: 22 }} />,
  SentimentSatisfied: (
    <SentimentSatisfiedAlt sx={{ color: positive, fontSize: 22 }} />
  ),
  SentimentSatisfiedAlt: (
    <SentimentSatisfiedAlt sx={{ color: positive, fontSize: 22 }} />
  ),
  RecordVoiceOver: <RecordVoiceOver sx={{ color: positive, fontSize: 22 }} />,
  Timer: <AccessTimeIcon sx={{ color:neutral, fontSize: 22 }} />,
  CheckCircleOutlineIcon: (
    <CheckCircleOutlineIcon sx={{ color: neutral, fontSize: 22 }} />
  ),
  ChatBubbleOutlineIcon: (
    <ChatBubbleOutlineIcon sx={{ color: neutral, fontSize: 22 }} />
  ),
};
function CommonKpisBox({ cardsData, cardLength }) {
  return (
    <>
      {cardsData?.map((item, index) => {
        return (
          <Grid
            key={index}
            item
            size={{ xs: 12, sm: 6, lg: cardLength }}
            sx={{ display: "flex", flexWrap: "wrap" }}
          >
            <Paper
              sx={{
                flex: 1,
                p: 2,
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                position: "relative",
                backgroundColor: item?.backgroundColor || "white",
              }}
            >
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Box>
                  <Typography
                    variant="subtitle2"
                    color="text.secondary"
                    gutterBottom
                  >
                    {item?.title || ""}
                  </Typography>
                  <Typography
                    variant="h4"
                    component=""
                    fontWeight="bold"
                    fontSize={"1.7rem"}
                    sx={{ mb: 1 }}
                  >
                    {item?.value || ""}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    bgcolor: item.iconBgColor,
                    borderRadius: 2,
                    width: 36,
                    height: 36,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {iconMap[item?.icon] || ""}
                </Box>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center" }}>
                {item?.trend?.direction === "up" && (
                  <>
                    <ArrowUpward
                      sx={{
                        color: "success.main",
                        fontSize: 16,
                        mr: 0.5,
                      }}
                    />
                    <Typography variant="body2" color="success.main">
                      {item?.trend?.value?`+${item?.trend?.value}`: "NA"}
                    </Typography>
                  </>
                )}
                {item?.trend?.direction === "down" && (
                  <>
                    <ArrowDownward
                      sx={{ color: "red", fontSize: 16, mr: 0.5 }}
                    />
                    <Typography variant="body2" color="red">
                      {item?.trend?.value || ""}
                    </Typography>
                  </>
                )}
                {item?.trend?.direction === "no change" && (
                  <>
                    
                    <Typography variant="body2" color="red">
                      {item?.trend?.value || ""}
                    </Typography>
                  </>
                )}
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ ml: 0.5 }}
                >
                  {item?.trend?.note || ""}
                </Typography>
              </Box>
            </Paper>
          </Grid>
        );
      })}
    </>
  );
}

export default CommonKpisBox;
